<template>
    <div class="map" :style="{height: height}">
        <el-amap
            vid="amap"
            class="amap"
            :zoom="zoom"
            :amap-manager="amapManager"
            :center="center"
            :events="events"
            :plugin="plugin"
        >
        </el-amap>
    </div>
</template>

<script>
import { AMapManager, lazyAMapApiLoaderInstance } from "vue-amap";
const  amapManager = new AMapManager();
export default {
    props: {
        height: {
            type: String,
            default: "300px"
        }
    },
    data() {
        const _this = this;
        return {
            map: null,
            amapManager,
            zoom: 15,
            center: [116.481485, 39.990464], // 地图初始化视图中心点
            events: {
                init(o) {
                    lazyAMapApiLoaderInstance.load().then(() => {
                        _this.initMap();
                    });
                },
            },
            plugin: [
                // 这里放扩展的插件
                {
                    pName: "Scale", // 比例尺
                    events: {
                        init() {},
                    },
                },
                {
                    pName: "ToolBar",
                    events: {
                        init() {},
                    },
                },
            ],
        };
    },

    methods: {
        initMap() {
            this.map = amapManager.getMap();
            let marker = new AMap.Marker({
                position: [116.481485, 39.990464], // 定位
            });
            marker.setMap(this.map);
        },
    },
};
</script>
